import Button from "../Button/Button";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { CheckBox } from "../CheckBox/CheckBox";
import { useState, useEffect } from "react";
import { Trans } from "react-i18next";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";

export const ValidatePage = ({ onFinish }) => {
  const { t, i18n } = useTranslation("homeModule");
  const { uid } = useUID();
  const trackEvent = useAmplitude();
  const [isLicenseMarked, setIsLicenseMarked] = useState(false);
  const [isContinuePressed, setIsContinuePressed] = useState(false);

  useEffect(() => {
    trackEvent("webapp_user_visited_preparation_page", uid);
  }, [uid, trackEvent]);

  return (
    <>
      <div className="validate-content-area">
        <div className="validate-header-container">
          <h2 className="validate-title">{t("validate-title")}</h2>
          <p className="validate-sub-title">{t("validate-sub-title")}</p>
        </div>
        <div className="validate-images-container">
          <img
            className="validate-image-1"
            src="validation-page-image1.png"
            alt="validation-page-image"
          />
          <img
            className="validate-image-2"
            src="validation-page-image2.png"
            alt="validation-page-image"
          />
        </div>
      </div>
      {!isContinuePressed && (
        <>
          <div className="license-option">
            <CheckBox
              onClick={() => setIsLicenseMarked((prevValue) => !prevValue)}
            />
            <p className="validate-license-text">
              <Trans
                ns="homeModule"
                i18nKey={"terms-text"}
                components={{
                  click: (
                    <a
                      href={`https://www.iqonic.ai${i18n.language === "de" ? "/de" : ""}/privacy`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="validate-license-text"
                    >
                      {" "}
                    </a>
                  ),
                }}
              />
            </p>
          </div>
          <div className="home-button-wrapper">
            <Button
              text={t("continue")}
              onClick={() => {
                trackEvent("webapp_user_press_continue_preparation_page", uid);
                setIsContinuePressed(true);
                setTimeout(() => onFinish(), 1000);
              }}
              disabled={!isLicenseMarked}
            />
          </div>
        </>
      )}
    </>
  );
};
